/* E-Tech61 "More <model> parts" row. Pairs with snippets/et61-model-parts.liquid.
   Tops the server-rendered cards up from search (templates/search.e6parts.liquid) when the model collection
   gave fewer than 12, and handles the quick "Add" buttons.
   Re-initialises when the theme editor re-renders the section and cleans up first. */
(() => {
  if (window.__e6mLoaded) return;
  window.__e6mLoaded = true;
  let teardown = null;

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  // Titles and models are compared with "(2018)" as "2018" and without inch marks, as in the Liquid snippet.
  const norm = (s) => String(s).replace(/ \(20/g, ' 20').replace(/"/g, '');
  // Same exact-model rule as the Liquid snippet: what follows the model must not continue its name.
  const exact = (model, alias) => {
    const m = norm(model).replace(/\)$/, '');
    const digit = /\d/.test(m);
    const stop = ['[\\w+]', '\\.\\d',
      ' (Pro|Max|Plus|Mini|Ultra|Lite|FE|Edge|Fold|Flip|XL|Neo|Fusion|Compact|Play|Core|SE|Premium|Smart|Go|E)(?![\\w-])',
      ' Power(?! (and|&|Buttons?|Flex|Key|Volume|On|Off|On/Off|Switch|Meter|Input|Adapter|Management|Cable|IC)(?!\\w))(?!\\w)',
      ' 20\\d\\d(?!\\w)', ' \\(?\\d{1,2}(st|nd|rd|th) Gen'];
    if (alias) stop.push(' [45]G(?!\\w)');
    if (!digit) stop.push(' \\d');
    if (!digit && /switch/i.test(m)) stop.push(' OLED');
    const re = new RegExp('(^|[^a-z0-9_])' + m.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?!' + stop.join('|') + ')', 'i');
    return (t) => re.test(norm(t));
  };
  const shortTitle = (t) => String(t).split('|')[0].trim().replace(/^For /, '');

  function init() {
    if (teardown) teardown();
    const root = document.getElementById('e6m');
    const dataEl = root && root.querySelector('script[data-e6m]');
    if (!dataEl) return;

    const D = JSON.parse(dataEl.textContent);
    const ac = new AbortController();
    const opt = { signal: ac.signal };
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const T = window.theme || {};
    const money = (cents) => (T.Currency && T.settings && T.settings.moneyFormat
      ? T.Currency.formatMoney(cents, T.settings.moneyFormat)
      : (cents / 100).toFixed(2));
    const list = root.querySelector('.e6m-list');
    const status = root.querySelector('[data-e6m-status]');

    // Card name without the model the heading already names (same rule as the Liquid snippet).
    function cardName(t) {
      const lt = t.toLowerCase();
      let name = t;
      for (const s of D.strip || []) {
        const at = s ? lt.indexOf(s.toLowerCase() + ' ') : -1;
        if (at < 0 || at >= 12 || /\d/.test(lt.slice(0, at))) continue;
        let rem = t.slice(at + s.length + 1);
        if (rem[0] === '(' && rem.includes(') ')) rem = rem.slice(rem.indexOf(') ') + 2);
        if (rem && !/^[/&,]/.test(rem)) name = rem;
        break;
      }
      // Compound pages: drop the model-code group after the model ("Pixel 7 (GVU6C / GQML3) OLED ..." -> "Pixel 7 OLED ...").
      const i = name.indexOf(' (');
      if (D.cmp && i > -1 && name.includes(') ', i) && name.slice(0, i).split(' ').length <= 4) {
        const tail = name.slice(name.indexOf(') ', i) + 2);
        if (tail.trim()) name = name.slice(0, i) + ' ' + tail;
      }
      return name;
    }

    // A trailing "(Colour)" goes on its own line so the name clamp never hides it.
    function nameHtml(n) {
      const m = / \(([^()]{1,23})\)$/.exec(n);
      return '<span class="e6m-name"><span class="e6m-nm">' + esc(m ? n.slice(0, m.index) : n) + '</span>'
        + (m ? ' <span class="e6m-var">(' + esc(m[1]) + ')</span>' : '') + '</span>';
    }

    function card(p) {
      const t = shortTitle(p.title);
      const action = p.vc === 1 && p.vid
        ? '<button type="button" class="e6m-add" data-id="' + p.vid + '" aria-label="Add ' + esc(t) + ' to cart">Add</button>'
        : '<a class="e6m-opt" href="' + esc(p.url) + '" aria-label="Choose options for ' + esc(t) + '">Choose options</a>';
      const img = p.img
        ? '<img src="' + esc(p.img) + '" srcset="' + esc(p.img.replace('width=360', 'width=180')) + ' 180w, ' + esc(p.img) + ' 360w"'
          + ' sizes="(min-width: 1100px) 180px, (min-width: 750px) 22vw, 44vw" alt="" loading="lazy" width="180" height="180">'
        : '';
      return '<li class="e6m-card" data-handle="' + esc(p.handle) + '"><a class="e6m-link" href="' + esc(p.url) + '">'
        + '<span class="e6m-img">' + img + '</span>'
        + (p.type ? '<span class="e6m-type">' + esc(p.type) + '</span> ' : '')
        + nameHtml(cardName(t)) + '</a>'
        + '<div class="e6m-foot"><span class="e6m-price">' + (p.pv ? '<small>From </small>' : '') + money(p.price) + '</span>' + action + '</div></li>';
    }

    function fallback() {
      const seen = new Set(Array.from(list.querySelectorAll('.e6m-card'), (li) => li.dataset.handle));
      const rules = D.models.map((m) => exact(m, (D.alias || []).includes(m)));
      Promise.all(D.models.slice(0, 4).map((m) => fetch(base + 'search?q=' + encodeURIComponent(m.replace(/[()"]/g, ''))
        + '&type=product&options%5Bprefix%5D=last&view=e6parts', opt)
        .then((r) => (r.ok ? r.json() : { products: [] }))
        .then((j) => (j.products || []).filter(Boolean))
        .catch(() => [])))
        .then((lists) => {
          const found = [];
          lists.flat().forEach((p) => {
            if (seen.has(p.handle) || p.id === D.pid || !p.available) return;
            if (!rules.some((r) => r(p.title))) return;
            seen.add(p.handle);
            found.push(p);
          });
          // One of each part type first (battery, buttons, port...), then the rest (e.g. colour versions).
          const types = new Set(Array.from(list.querySelectorAll('.e6m-type'), (el) => el.textContent));
          const fresh = found.filter((p) => !types.has(p.type) && types.add(p.type));
          found.splice(0, found.length, ...fresh, ...found.filter((p) => !fresh.includes(p)));
          // When the row is on screen (or scrolled past), don't let the grid grow past the rows the skeletons
          // hold, or the content below jumps. "View all" covers the rest.
          const onScreen = root.getBoundingClientRect().top < window.innerHeight;
          let room = D.need;
          if (onScreen && getComputedStyle(list).display === 'grid') {
            const cols = getComputedStyle(list).gridTemplateColumns.split(' ').length;
            room = Math.ceil(list.children.length / cols) * cols - list.querySelectorAll('.e6m-card').length;
          }
          found.length = Math.min(found.length, D.need, room);
          list.querySelectorAll('.e6m-skel').forEach((li) => li.remove());
          list.insertAdjacentHTML('beforeend', found.map(card).join(''));
          finish(onScreen);
        })
        .catch((e) => { if (e.name !== 'AbortError') finish(root.getBoundingClientRect().top < window.innerHeight); });
    }

    function finish(onScreen) {
      root.removeAttribute('aria-busy');
      if (list.querySelector('.e6m-card')) {
        list.querySelectorAll('.e6m-skel').forEach((li) => li.remove());
        return;
      }
      // Nothing to show: hide the row if it is below the screen; on screen, keep its height with a short note.
      if (!onScreen) { root.hidden = true; return; }
      list.style.minHeight = list.offsetHeight + 'px';
      list.innerHTML = '<li class="e6m-empty">No other parts listed for this model yet. Use View all to search the full range.</li>';
    }

    function add(btn) {
      if (btn.getAttribute('aria-busy') === 'true') return;
      const name = (btn.getAttribute('aria-label') || '').replace(/^Add /, '').replace(/ to cart$/, '');
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
      btn.setAttribute('aria-busy', 'true');
      status.textContent = '';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: +btn.dataset.id, quantity: 1 }], sections, sections_url: location.pathname }),
        signal: ac.signal
      })
        .then((r) => r.json())
        .then((res) => fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, signal: ac.signal })
          .then((r) => r.json())
          .then((cart) => {
            const pub = T.pubsub && T.pubsub.PUB_SUB_EVENTS;
            if (res.status) {
              status.textContent = res.description || res.message || 'Could not add ' + name + ' to the cart.';
              if (pub) T.pubsub.publish(T.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-bundle', cart });
              return;
            }
            // A section that failed to render comes back as null; the theme's cart update would throw on it,
            // so the drawer re-fetches itself instead (cart:refresh) and opens.
            const sectionsOk = res.sections && Object.values(res.sections).every(Boolean);
            if (sectionsOk) cart.sections = res.sections;
            status.textContent = 'Added ' + name + ' to the cart. Cart now has ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + '.';
            if (pub) T.pubsub.publish(T.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-bundle', cart });
            const drawer = document.querySelector('cart-drawer');
            if (!drawer || typeof drawer.show !== 'function' || (T.settings && T.settings.cartType === 'page')) location.href = base + 'cart';
            else if (sectionsOk) drawer.show(btn);
            else document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          }))
        .catch((e) => { if (e.name !== 'AbortError') status.textContent = 'Something went wrong. Please try again.'; })
        .finally(() => btn.removeAttribute('aria-busy'));
    }

    root.addEventListener('click', (e) => {
      const btn = e.target.closest('.e6m-add');
      if (btn) add(btn);
    }, opt);
    // Mobile row scrolls sideways: bring a card that gets keyboard focus fully into view.
    list.addEventListener('focusin', (e) => {
      const c = e.target.closest('.e6m-card');
      if (!c || list.scrollWidth <= list.clientWidth) return;
      const lr = list.getBoundingClientRect();
      const cr = c.getBoundingClientRect();
      if (cr.left < lr.left || cr.right > lr.right) list.scrollLeft += cr.left - lr.left - 2;
    }, opt);
    if (D.need > 0) fallback();

    teardown = () => { ac.abort(); teardown = null; };
  }

  // Theme editor: scripts don't re-run when a section re-renders, so re-initialise here.
  document.addEventListener('shopify:section:unload', (e) => { if (teardown && e.target.querySelector('#e6m')) teardown(); });
  document.addEventListener('shopify:section:load', (e) => { if (e.target.querySelector('#e6m')) init(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
